export default response => ({
  userFlags: response.user_flags,
  projectFlags: response.project_flags,
  organizationFlags: response.organization_flags || {},
});
